import React from "react";
import { Box, Button, MenuItem } from "@mui/material";
import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-duotone-svg-icons";
import PrimaryButton from "@/src/mui-custom/button/button-primary";
import SuccessButton from "@/src/mui-custom/button/button-success";
import JournalsDesktopMenuProps from "@/src/_types/journals-desktop-menu-props";
import { PAPER_BACKGROUND } from "@/src/constant/constant";

const DesktopMenu = ({ menuItems, authorGuide, submission, isFixed }: JournalsDesktopMenuProps) => {

    return (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", flexGrow: 1 }}>
                {
                    menuItems.map((item, index) =>
                        item.children ? (
                            <Box
                                key={index}
                                py={.25}
                                sx={{
                                    position: 'relative',
                                    '&:hover .submenu': {
                                        display: 'block'
                                    },
                                }}
                            >
                                <Button
                                    sx={{
                                        color: "custom.teal",
                                        textTransform: "none",
                                        fontSize: "1rem",
                                        fontWeight: 700,
                                        marginRight: 0.5,
                                        display: "flex",
                                        gap: 0.3,
                                    }}
                                >
                                    <i className={item.icon} />
                                    {item.label}
                                    <FontAwesomeIcon
                                        icon={faChevronDown}
                                    />
                                </Button>
                                <Box
                                    className="submenu"
                                    py={.5}
                                    sx={{
                                        display: 'none',
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        zIndex: 10,
                                        backgroundColor: "#ECE6E0",
                                        backgroundImage: `url(${PAPER_BACKGROUND})`,
                                        borderRadius: '0 0 .5rem .5rem',
                                        border: '1px solid rgba(0, 0, 0, .15)',
                                        borderTop: 'none',
                                        color: "#484641"
                                    }}
                                >
                                    {
                                        item.children.map((child, childIndex) => (
                                            <MenuItem
                                                component={Link}
                                                key={childIndex}
                                                href={child.link ?? "#"}
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 0.3,
                                                    fontSize: ".9rem",
                                                    fontWeight: 700,
                                                    "&:hover": {
                                                        color: "#0c7f8b",
                                                        backgroundColor: "rgba(61, 60, 58, 0.3)",
                                                    },
                                                }}
                                            >
                                                <i className={child.icon} />
                                                {
                                                    child.label
                                                }
                                            </MenuItem>
                                        ))
                                    }
                                </Box>
                            </Box>
                        ) : (
                            <Button
                                key={index}
                                component={Link}
                                sx={{
                                    color: "custom.teal",
                                    textTransform: "none",
                                    fontSize: "1rem",
                                    fontWeight: 700,
                                    marginRight: 0.5,
                                    display: "flex",
                                    gap: 0.3,
                                    py: .25
                                }}
                                href={item.link ?? "#"}
                            >
                                <i className={item.icon} />
                                {
                                    item.label
                                }
                            </Button>
                        )
                    )
                }
            </Box>
            {
                !isFixed && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <SuccessButton
                            sx={{
                                borderRadius: ".75rem",
                                fontWeight: 700,
                                fontSize: "1.1rem",
                                display: "flex",
                                alignItems: "center",
                                gap: 0.3,
                                textShadow: 'none',
                                padding: '.15rem 1rem'
                            }}
                            href={authorGuide.link ?? '#'}
                        >
                            <i className={authorGuide.icon} />
                            {
                                authorGuide.label
                            }
                        </SuccessButton>
                        <PrimaryButton
                            sx={{
                                borderRadius: ".75rem",
                                fontWeight: 700,
                                fontSize: "1.1rem",
                                display: "flex",
                                alignItems: "center",
                                gap: 0.3,
                                textShadow: 'none',
                                padding: '.15rem 1rem'
                            }}
                            href={submission.link ?? '#'}
                        >
                            <i className={submission.icon} />
                            {
                                submission.label
                            }
                        </PrimaryButton>
                    </Box>
                )
            }
        </Box>
    );
};

export default DesktopMenu;
